import { z } from "zod";

import { effectBuildSchema } from "../../shared/index.ts";

export const addEffectActionSchema = z.object({
  type: z.literal("ADD_EFFECT"),
  payload: z.object({
    responseId: z.number().int(),
    effect: effectBuildSchema,
  }),
});

export type AddEffectAction = z.infer<typeof addEffectActionSchema>;

export const reorderEffectActionSchema = z.object({
  type: z.literal("REORDER_EFFECT"),
  payload: z.object({
    id: z.number().int(),
    newIndex: z.number().int().nonnegative(),
  }),
});

export type ReorderEffectAction = z.infer<typeof reorderEffectActionSchema>;

export const removeEffectActionSchema = z.object({
  type: z.literal("REMOVE_EFFECT"),
  payload: z.object({
    id: z.number().int(),
  }),
});

export type RemoveEffectAction = z.infer<typeof removeEffectActionSchema>;

export const updateEffectConfigActionSchema = z.object({
  type: z.literal("UPDATE_EFFECT_CONFIG"),
  payload: z.object({
    id: z.number().int(),
    config: z.record(z.unknown()),
  }),
});

export type UpdateEffectConfigAction = z.infer<typeof updateEffectConfigActionSchema>;
